import React from 'react'
import { userUtil } from '@liepin/js-core4c-fe';
import Header from '../../../header/Header';
import { useFramework, useUserInfo } from '../../../hooks';

function DefaultHeader() {

  const {state: { visibleCity, quickMenu }} = useFramework();
  const { userInfo } = useUserInfo();

  return (
    <Header
      userInfo={ userInfo }
      isLogin={ userUtil.isLogin }
      visibleCity={visibleCity}
      quickMenu={quickMenu}
    />
  )
}

export default DefaultHeader
